(function(){
  // scroll reveal
  var revealEls = document.querySelectorAll('.reveal');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .15 });
  revealEls.forEach(function(el){ io.observe(el); });

  // ---------- i18n (EN / AR toggle) ----------
  var I18N = {
    en: {
      inspectorLink: 'Inspector access',
      partnerLink: 'Partners',
      heroEyebrow: 'PRE-PURCHASE VEHICLE DIAGNOSTICS',
      heroH1: 'Know the car<br><em>before you own it.</em>',
      heroLede: 'An independent inspector, booked through Cardiagnos, checks the vehicle — exterior, interior and mechanical — and gives you a clear written report of what they observed before you decide to buy.',
      scanReadout: '51 CHECKPOINTS · SCAN COMPLETE',
      dragHint: 'DRAG TO ROTATE',
      clickOpenHint: 'CLICK THE CAR TO OPEN THE DOORS',
      scrollCue: 'SCROLL',
      videoEyebrow: 'FULL INSPECTION · UNEDITED FOOTAGE',
      videoHeading: 'Watch a real inspection happen.',
      videoCta: 'Book your inspection →',
      servicesEyebrow: 'CHOOSE YOUR SCAN',
      servicesHeading: 'Two levels of scrutiny.',
      servicesLede: 'Both are performed on-site by an independent inspector (a partner business) that you book through Cardiagnos, which is only the broker. Pick the depth that matches how much is riding on this purchase.',
      fullBadge: 'Most thorough',
      full: 'Full Inspection',
      normalBadge: 'Quick check',
      normal: 'Normal Inspection',
      priceFrom: 'From',
      currency: 'SR',
      fullLi1: 'Engine, transmission & differential',
      fullLi2: 'Computer, sensors & electrical',
      fullLi3: 'Body, paint & chassis',
      fullLi4: 'Suspension, brakes & tires',
      fullLi5: 'Under-vehicle inspection',
      fullLi6: 'Road test',
      fullLi7: 'Report delivered via WhatsApp',
      fullLi8: 'Mojaz accident summary report', fullLi8c: '+50 SR add-on',
      normalLi1: 'Engine inspection',
      normalLi2: 'Road test',
      normalLi3: 'Transmission inspection',
      normalLi4: 'Computer & sensors check',
      normalLi5: 'Differential check',
      bookBtn: 'Book & pay upfront',
      processEyebrow: 'THE PROCESS',
      processHeading: 'Three steps, start to finish.',
      step1Title: 'Pay & book', step1Desc: 'Choose your inspection and pay upfront — your slot is secured the moment payment clears.',
      step2Title: 'Inspector visits', step2Desc: 'An independent inspector examines the vehicle in person and rates each zone against the checklist.',
      step3Title: 'Report delivered', step3Desc: 'Your finished report lands on WhatsApp or email — whichever you chose at checkout.',
      sideStripTag: 'SIDE PROFILE · ZONE MAP',
      demoEyebrow: 'TRY IT',
      demoHeading: 'This is the actual flow.',
      demoLede: 'This is the real booking flow — completing it takes you to secure checkout.',
      demoSelectTitle: 'Confirm your inspection',
      demoSelectLede: "Pick a service and where you'd like your report delivered.",
      redirecting: 'Redirecting to checkout…',
      payError: "Couldn't start checkout — please try again.",
      expressCheckout: 'Express checkout',
      or: 'OR',
      contactLabelWhatsapp: 'Your WhatsApp number',
      contactLabelEmail: 'Your email address',
      contactPlaceholderWhatsapp: '+966 5X XXX XXXX',
      contactPlaceholderEmail: 'you@example.com',
      contactErrorWhatsapp: 'Please enter a valid WhatsApp number.',
      contactErrorEmail: 'Please enter a valid email address.',
      contactSummaryLabel: 'Reaching you at',
      vehicleFieldLabel: 'Your vehicle (optional)',
      vehicleMakePh: 'Make',
      vehicleModelPh: 'Model',
      vehicleYearPh: 'Year',
      reportLangFieldLabel: 'Report language',
      reportLangEn: 'English',
      reportLangAr: 'Arabic',
      customerNotesLabel: 'Anything the inspector should know? (optional)',
      customerNotesPh: 'e.g. a scratch on the rear bumper, a warning light that came on…',
      deliverVia: 'Deliver my report via',
      whatsapp: 'WhatsApp',
      email: 'Email',
      continueToPayment: 'Continue to payment',
      payTag: 'Payment upfront',
      payTitle: 'Complete your payment',
      delivery: 'Delivery',
      totalDueNow: 'Total due now',
      payNow: 'Pay now',
      back: '← back',
      secureCheckout: 'SECURE CHECKOUT',
      thanksTitle: 'Payment received',
      thanksP1: 'Your inspection is booked. An inspector will contact you shortly to arrange the visit.',
      thanksP2: "Once it's complete, your report will be sent straight to your {channel}.",
      startOver: 'Start over',
      footerFinePre: 'The booking flow above shows how it works — ',
      footerFineLink: 'inspectors, click here to open the report tool →',
      trustEyebrow: 'WHO WE ARE',
      trustHeading: 'New to Saudi Arabia. Verify us before you pay.',
      trustLede: "Cardiagnos started in Sweden, and we're now bringing the same inspection standard to the Saudi market. You're more than welcome to call us and get to know us better — ask us anything you're wondering about.",
      trustCallTitle: 'Call before you book',
      trustCallDesc: 'Speak to a real person and ask us anything about the process.',
      trustVisitTitle: 'Meet us in person',
      trustVisitDesc: 'Arrange a time to visit and see how we work.',
      trustMechanicTitle: 'Bring your own mechanic',
      trustMechanicDesc: "Have someone you already trust look over the vehicle alongside our report — we're glad to have the extra pair of eyes.",
      heroCvBtn: 'Car valuation',
      heroCvSub: 'Know what your car is worth',
      heroCvDesc: 'Answer a few quick questions and get an estimated market price for your car — free.',
      heroSampleBtn: 'Sample report', heroSampleSub: 'See an example of what the full report looks like',
      trustPhone: '', trustAddress: '',
      reportLangSv: 'Swedish',
      countryFieldLabel: 'Country',
      countryPh: 'Select a country',
      cityFieldLabel: 'City',
      cityPh: 'Select a city',
      cityError: 'Please choose the city where the inspection should happen.',
      brandName: 'SightCore',
      brandTagline: "We see what others don't.",
      countryError: 'Please choose the country where the inspection should happen.',
      countrySE: 'Sweden',
      countrySA: 'Saudi Arabia',
      citySummaryLabel: 'Location'
    },
    ar: {
      inspectorLink: 'دخول الفاحص',
      partnerLink: 'دخول الشركاء',
      heroEyebrow: 'فحص السيارة قبل الشراء',
      heroH1: 'اعرف حالة السيارة<br><em>قبل ما تملكها.</em>',
      heroLede: 'يفحص مفتّش مستقل تحجزه عبر Cardiagnos المركبة — الخارج والداخل والميكانيكا — ويسلّمك تقريرًا مكتوبًا واضحًا بما لاحظه قبل أن تقرّر الشراء.',
      scanReadout: '٥١ نقطة فحص · اكتمل المسح',
      dragHint: 'اسحب للتدوير',
      clickOpenHint: 'اضغط على السيارة لفتح الأبواب',
      scrollCue: 'مرّر للأسفل',
      videoEyebrow: 'فحص كامل · تصوير غير مُقصوص',
      videoHeading: 'شاهد فحصاً حقيقياً وهو يحدث.',
      videoCta: 'احجز فحصك ←',
      servicesEyebrow: 'اختر نوع الفحص',
      servicesHeading: 'مستويان من الدقة.',
      servicesLede: 'يُنفَّذ كلا الفحصين ميدانيًا بواسطة مفتّش مستقل (منشأة شريكة) تحجزه عبر Cardiagnos، وهي مجرد وسيط. اختر العمق المناسب لحجم القرار الذي تنوي اتخاذه.',
      fullBadge: 'الأكثر شمولاً',
      full: 'الفحص الكامل',
      normalBadge: 'فحص سريع',
      normal: 'الفحص العادي',
      priceFrom: 'يبدأ من',
      currency: 'ريال',
      fullLi1: 'المحرك والقير والدفرنس',
      fullLi2: 'الكمبيوتر والحساسات والكهرباء',
      fullLi3: 'البودي والرش والشاصي',
      fullLi4: 'العفشة والفرامل والإطارات',
      fullLi5: 'فحص أسفل السيارة',
      fullLi6: 'تجربة السيارة على الطريق',
      fullLi7: 'تقرير الفحص على الواتساب',
      fullLi8: 'تقرير موجز (Mojaz) عن الحوادث', fullLi8c: 'إضافة +50 ريال',
      normalLi1: 'فحص المحرك (المكينة)',
      normalLi2: 'تجربة السيارة على الطريق',
      normalLi3: 'فحص ناقل الحركة (القير)',
      normalLi4: 'فحص الكمبيوتر والحساسات',
      normalLi5: 'فحص الدفرنس',
      bookBtn: 'احجز وادفع مقدماً',
      processEyebrow: 'خطوات العمل',
      processHeading: 'ثلاث خطوات من البداية للنهاية.',
      step1Title: 'ادفع واحجز', step1Desc: 'اختر نوع الفحص وادفع مقدماً — يتأكد حجزك فور إتمام الدفع.',
      step2Title: 'زيارة الفاحص', step2Desc: 'يعاين مفتّش مستقل السيارة ميدانيًا ويقيّم كل منطقة حسب القائمة.',
      step3Title: 'استلام التقرير', step3Desc: 'يصلك التقرير النهائي عبر واتساب أو البريد الإلكتروني — حسب اختيارك عند الدفع.',
      sideStripTag: 'الملف الجانبي · خريطة المناطق',
      demoEyebrow: 'جرّبها بنفسك',
      demoHeading: 'هذه هي رحلة الحجز الفعلية.',
      demoLede: 'هذه رحلة الحجز الحقيقية — إتمامها يأخذك إلى صفحة الدفع الآمنة.',
      demoSelectTitle: 'أكّد نوع الفحص',
      demoSelectLede: 'اختر الخدمة والطريقة التي تفضّل استلام تقريرك من خلالها.',
      redirecting: 'جارِ التحويل إلى صفحة الدفع…',
      payError: 'تعذّر بدء الدفع — الرجاء المحاولة مرة أخرى.',
      expressCheckout: 'الدفع السريع',
      or: 'أو',
      contactLabelWhatsapp: 'رقم الواتساب',
      contactLabelEmail: 'البريد الإلكتروني',
      contactPlaceholderWhatsapp: '+966 5X XXX XXXX',
      contactPlaceholderEmail: 'you@example.com',
      contactErrorWhatsapp: 'الرجاء إدخال رقم واتساب صحيح.',
      contactErrorEmail: 'الرجاء إدخال بريد إلكتروني صحيح.',
      contactSummaryLabel: 'سيتم التواصل معك على',
      vehicleFieldLabel: 'سيارتك (اختياري)',
      vehicleMakePh: 'الشركة المصنعة',
      vehicleModelPh: 'الموديل',
      vehicleYearPh: 'سنة الصنع',
      reportLangFieldLabel: 'لغة التقرير',
      reportLangEn: 'الإنجليزية',
      reportLangAr: 'العربية',
      customerNotesLabel: 'هل هناك ما يجب أن يعرفه الفاحص؟ (اختياري)',
      customerNotesPh: 'مثال: خدش في الصادم الخلفي، أو إضاءة تحذير ظهرت مؤخراً…',
      deliverVia: 'استلام التقرير عبر',
      whatsapp: 'واتساب',
      email: 'البريد الإلكتروني',
      continueToPayment: 'المتابعة للدفع',
      payTag: 'الدفع مقدماً',
      payTitle: 'أكمل عملية الدفع',
      delivery: 'طريقة التسليم',
      totalDueNow: 'الإجمالي المستحق الآن',
      payNow: 'ادفع الآن',
      back: 'رجوع ←',
      secureCheckout: 'دفع آمن',
      thanksTitle: 'تم استلام الدفعة',
      thanksP1: 'تم تأكيد حجز فحصك. سيتواصل معك الفاحص قريباً لتحديد موعد الزيارة.',
      thanksP2: 'بعد اكتمال الفحص، سيُرسل تقريرك مباشرة إلى {channel}.',
      startOver: 'البدء من جديد',
      footerFinePre: 'رحلة الحجز أعلاه توضح آلية العمل — ',
      footerFineLink: 'الفاحصون: اضغطوا هنا لفتح أداة التقرير ←',
      trustEyebrow: 'من نحن',
      trustHeading: 'جديدون في السوق السعودي — تحقق منا قبل الدفع',
      trustLede: 'بدأت Cardiagnos في السويد، والآن نجلب نفس معايير الفحص إلى السوق السعودي. يسعدنا جداً أن تتصل بنا للتعرف علينا بشكل أفضل — واسألنا عن أي شيء يخطر ببالك.',
      trustCallTitle: 'اتصل قبل الحجز',
      trustCallDesc: 'تحدث مع شخص حقيقي واسألنا عن أي شيء يخص العملية.',
      trustVisitTitle: 'قابلنا شخصياً',
      trustVisitDesc: 'رتّب موعداً لزيارتنا ومشاهدة كيف نعمل.',
      trustMechanicTitle: 'أحضر فنيّك الخاص',
      trustMechanicDesc: 'اطلب من شخص تثق به مسبقاً مراجعة السيارة إلى جانب تقريرنا — يسعدنا وجود عين إضافية.',
      heroCvBtn: 'تقييم السيارة',
      heroCvSub: 'اعرف كم تساوي سيارتك',
      heroCvDesc: 'أجب عن بضعة أسئلة سريعة واحصل على سعر تقديري لسيارتك في السوق — مجانًا.',
      heroSampleBtn: 'نموذج تقرير', heroSampleSub: 'شاهد مثالًا على شكل التقرير الكامل',
      trustPhone: '', trustAddress: '',
      reportLangSv: 'السويدية',
      countryFieldLabel: 'الدولة',
      countryPh: 'اختر الدولة',
      cityFieldLabel: 'المدينة',
      cityPh: 'اختر المدينة',
      cityError: 'يرجى اختيار المدينة التي سيتم فيها الفحص.',
      brandName: 'عين الخلل',
      brandTagline: 'نرى ما لا يراه الآخرون',
      countryError: 'يرجى اختيار الدولة التي سيتم فيها الفحص.',
      countrySE: 'السويد',
      countrySA: 'السعودية',
      citySummaryLabel: 'الموقع'
    },
    sv: {
      inspectorLink: 'Inspektörsinloggning',
      partnerLink: 'Partnerinloggning',
      heroEyebrow: 'FORDONSDIAGNOSTIK FÖRE KÖP',
      heroH1: 'Lär känna bilen<br><em>innan den blir din.</em>',
      heroLede: 'En fristående inspektör som du bokar via Cardiagnos går igenom bilen – exteriör, interiör och mekanik – och ger dig en tydlig skriftlig rapport över vad inspektören observerat innan du bestämmer dig för att köpa.',
      scanReadout: '51 KONTROLLPUNKTER · SKANNING KLAR',
      dragHint: 'DRA FÖR ATT ROTERA',
      clickOpenHint: 'KLICKA PÅ BILEN FÖR ATT ÖPPNA DÖRRARNA',
      scrollCue: 'SKROLLA',
      videoEyebrow: 'FULLSTÄNDIG BESIKTNING · OKLIPPT FILM',
      videoHeading: 'Se en riktig besiktning ske.',
      videoCta: 'Boka din besiktning →',
      servicesEyebrow: 'VÄLJ DIN KONTROLL',
      servicesHeading: 'Två nivåer av granskning.',
      servicesLede: 'Båda utförs på plats av en fristående inspektör (ett partnerföretag) som du bokar via Cardiagnos, som enbart är förmedlare. Välj den nivå som motsvarar hur mycket som står på spel i affären.',
      fullBadge: 'Mest grundlig',
      full: 'Fullständig besiktning',
      normalBadge: 'Snabb koll',
      normal: 'Normal besiktning',
      priceFrom: 'Från',
      currency: 'kr',
      fullLi1: 'Motor, växellåda och differential',
      fullLi2: 'Dator, sensorer och elsystem',
      fullLi3: 'Kaross, lack och chassi',
      fullLi4: 'Fjädring, bromsar och däck',
      fullLi5: 'Kontroll under bilen',
      fullLi6: 'Provkörning',
      fullLi7: 'Rapport levereras via WhatsApp',
      fullLi8: 'Mojaz skaderapport', fullLi8c: '+50 kr tillägg',
      normalLi1: 'Motorkontroll',
      normalLi2: 'Provkörning',
      normalLi3: 'Kontroll av växellåda',
      normalLi4: 'Kontroll av dator och sensorer',
      normalLi5: 'Kontroll av differential',
      bookBtn: 'Boka och betala i förskott',
      processEyebrow: 'SÅ GÅR DET TILL',
      processHeading: 'Tre steg, från start till mål.',
      step1Title: 'Betala och boka', step1Desc: 'Välj din besiktning och betala i förskott — din tid är säkrad så snart betalningen gått igenom.',
      step2Title: 'Inspektören kommer', step2Desc: 'En fristående inspektör undersöker bilen på plats och bedömer varje del mot checklistan.',
      step3Title: 'Rapporten levereras', step3Desc: 'Din färdiga rapport kommer via WhatsApp eller e-post — det du valde i kassan.',
      sideStripTag: 'SIDOPROFIL · ZONKARTA',
      demoEyebrow: 'TESTA',
      demoHeading: 'Det här är hela flödet.',
      demoLede: 'Det här är den riktiga bokningen — när du är klar går du vidare till säker kassa.',
      demoSelectTitle: 'Bekräfta din besiktning',
      demoSelectLede: 'Välj tjänst och hur du vill få din rapport levererad.',
      redirecting: 'Skickar dig till kassan…',
      payError: 'Kunde inte starta kassan — försök igen.',
      expressCheckout: 'Expresskassa',
      or: 'ELLER',
      contactLabelWhatsapp: 'Ditt WhatsApp-nummer',
      contactLabelEmail: 'Din e-postadress',
      contactPlaceholderWhatsapp: '+46 70 123 45 67',
      contactPlaceholderEmail: 'du@exempel.se',
      contactErrorWhatsapp: 'Ange ett giltigt WhatsApp-nummer.',
      contactErrorEmail: 'Ange en giltig e-postadress.',
      contactSummaryLabel: 'Vi når dig på',
      vehicleFieldLabel: 'Ditt fordon (frivilligt)',
      vehicleMakePh: 'Märke',
      vehicleModelPh: 'Modell',
      vehicleYearPh: 'Årsmodell',
      reportLangFieldLabel: 'Rapportspråk',
      reportLangEn: 'Engelska',
      reportLangAr: 'Arabiska',
      customerNotesLabel: 'Något inspektören bör veta? (frivilligt)',
      customerNotesPh: 't.ex. en repa på bakre stötfångaren, en varningslampa som tänts…',
      deliverVia: 'Leverera min rapport via',
      whatsapp: 'WhatsApp',
      email: 'E-post',
      continueToPayment: 'Fortsätt till betalning',
      payTag: 'Betalning i förskott',
      payTitle: 'Slutför din betalning',
      delivery: 'Leverans',
      totalDueNow: 'Att betala nu',
      payNow: 'Betala nu',
      back: '← tillbaka',
      secureCheckout: 'SÄKER KASSA',
      thanksTitle: 'Betalning mottagen',
      thanksP1: 'Din besiktning är bokad. En inspektör kontaktar dig inom kort för att boka in besöket.',
      thanksP2: 'När den är klar skickas din rapport direkt till din {channel}.',
      startOver: 'Börja om',
      footerFinePre: 'Bokningsflödet ovan visar hur det fungerar — ',
      footerFineLink: 'inspektörer, klicka här för att öppna rapportverktyget →',
      trustEyebrow: 'VILKA VI ÄR',
      trustHeading: 'Nya i Saudiarabien — kontrollera oss innan du betalar',
      trustLede: 'Cardiagnos startade i Sverige, och nu tar vi samma besiktningsstandard till den saudiska marknaden. Du är mer än välkommen att ringa oss och lära känna oss bättre — fråga oss om vad som helst du undrar över.',
      trustCallTitle: 'Ring innan du bokar',
      trustCallDesc: 'Prata med en riktig person och fråga oss om vad som helst kring processen.',
      trustVisitTitle: 'Träffa oss personligen',
      trustVisitDesc: 'Boka en tid för att besöka oss och se hur vi arbetar.',
      trustMechanicTitle: 'Ta med din egen mekaniker',
      trustMechanicDesc: 'Låt någon du redan litar på granska bilen tillsammans med vår rapport — vi uppskattar ett extra par ögon.',
      heroCvBtn: 'Bilvärdering',
      heroCvSub: 'Vet vad din bil är värd',
      heroCvDesc: 'Svara på några snabba frågor och få ett uppskattat marknadspris för din bil — gratis.',
      heroSampleBtn: 'Exempelrapport', heroSampleSub: 'Se ett exempel på hur hela rapporten ser ut (på engelska)',
      trustPhone: '', trustAddress: '',
      reportLangSv: 'Svenska',
      countryFieldLabel: 'Land',
      countryPh: 'Välj land',
      cityFieldLabel: 'Stad',
      cityPh: 'Välj stad',
      cityError: 'Välj den stad där besiktningen ska ske.',
      brandName: 'Klarsikt',
      brandTagline: 'Vi ser vad andra inte ser.',
      countryError: 'Välj det land där besiktningen ska ske.',
      countrySE: 'Sverige',
      countrySA: 'Saudiarabien',
      citySummaryLabel: 'Plats'
    }
  };
  /* Theme-editor overrides (see cardiagnos-landing.liquid's schema). Every
     field is optional -- a blank setting leaves the built-in wording above
     untouched, so clearing a box in the editor restores the default instead
     of blanking the page. Merged before anything renders, so the rest of the
     file can keep reading I18N exactly as it always has. */
  var LCFG = window.CARDIAGNOS_LANDING_CONFIG || {};
  (function applyThemeSettingOverrides(){
    var t = LCFG.t || {};
    // Every language I18N defines, not a hard-coded pair -- Swedish was
    // silently excluded here when it was added, so theme-editor overrides
    // never reached it.
    Object.keys(I18N).forEach(function(lang){
      var over = t[lang];
      if(!over || !I18N[lang]) return;
      Object.keys(over).forEach(function(k){
        var v = over[k];
        if(typeof v === 'string' && v.trim()) I18N[lang][k] = v;
      });
    });
  })();

  // Every OTHER custom page (car-value, become-a-partner, partner-hub,
  // partner-activate) already shares this exact key so a language choice
  // made on any one of them carries over to the rest -- this page used its
  // own separate 'cardiagnos_landing_lang' key instead, which meant picking
  // a language on the very first page a visitor lands on (this one) was
  // the one choice that never actually followed them anywhere else on the
  // site. Matching the shared key is the whole fix.
  I18N.sv.full = 'Köpbesiktning – Fullständig';
    I18N.sv.normal = 'Köpbesiktning – Normal';
      I18N.en.full = 'Full Pre-Purchase Inspection';
        I18N.en.normal = 'Normal Pre-Purchase Inspection';
          I18N.ar.full = '\u0641\u062d\u0635 \u0634\u0627\u0645\u0644 \u0642\u0628\u0644 \u0627\u0644\u0634\u0631\u0627\u0621';
            I18N.ar.normal = '\u0641\u062d\u0635 \u0639\u0627\u062f\u064a \u0642\u0628\u0644 \u0627\u0644\u0634\u0631\u0627\u0621';
              var LANG_KEY = 'vir_lang';
  // Default to whatever locale Shopify actually served this page in (geo /
  // URL prefix / previous choice) rather than always English -- a Swedish
  // visitor should see, and check out in, Swedish without having to click a
  // flag. An explicit saved choice still wins over that.
  var _srvLocale = (window.CARDIAGNOS_LANDING_CONFIG || {}).storefrontLocale;
  var currentLang = (_srvLocale === 'ar' || _srvLocale === 'sv') ? _srvLocale : 'en';
  try {
    // Falls back to the old landing-only key so a visitor who already had a
    // preference saved under it (from before this fix) doesn't see their
    // choice silently reset the first time they come back -- vir_lang wins
    // once it exists, which is immediately after their next language click.
    var savedLang = localStorage.getItem(LANG_KEY) || localStorage.getItem('cardiagnos_landing_lang');
    if(savedLang === 'en' || savedLang === 'ar' || savedLang === 'sv') currentLang = savedLang;
  } catch(e){}
  // A language in the address (cardiagons.com/ar, /sv) wins over a saved
  // choice -- someone opening the Arabic link should get Arabic -- and
  // becomes the saved choice from then on.
  var _urlLang = (location.pathname.match(/^\/(ar|sv|en)(\/|$)/) || [])[1];
  if(_urlLang){ currentLang = _urlLang; try{ localStorage.setItem(LANG_KEY, _urlLang); }catch(e){} }

  function T(key){
    var dict = I18N[currentLang] || I18N.en;
    return (key in dict) ? dict[key] : (I18N.en[key] || '');
  }

  function renderThanksP2(){
    var p = document.getElementById('thanksP2');
    var chanEl = document.getElementById('thanksChannel');
    if(!p) return;
    var channelWord = chanEl ? chanEl.textContent : T('whatsapp');
    var parts = T('thanksP2').split('{channel}');
    p.textContent = '';
    p.appendChild(document.createTextNode(parts[0]));
    var span = document.createElement('span');
    span.className = 'chan';
    span.id = 'thanksChannel';
    span.textContent = channelWord;
    p.appendChild(span);
    if(parts[1]) p.appendChild(document.createTextNode(parts[1]));
  }

  /* The two service cards' feature lists are editable from the theme editor
     as one-feature-per-line text (see the schema's "Feature lists"). Icons
     stay positional -- the Nth line keeps the Nth icon already in the
     markup, and any line beyond that gets a plain checkmark -- so editing
     wording never costs the icons. Icons are captured ONCE from the
     original markup (identical across languages, so this is safe) purely
     to reuse their SVGs; the TEXT for each <li> always comes from either
     the theme-setting override or -- when there's no override, the normal
     case -- I18N itself for whichever language is current.

     This used to restore a frozen HTML snapshot of the list (captured at
     page load, in whatever language rendered first) as its "no override"
     fallback. That snapshot's text never changed after capture, so
     switching to a language with no custom feature-list override put the
     PAGE-LOAD language's wording back on screen with no further
     translation pass ever applied to it -- e.g. switching to Swedish left
     the feature lists in English, because Swedish had no override
     configured and the fallback silently reused the English snapshot
     instead of reading Swedish out of I18N. Rebuilding from I18N (via T())
     on every render instead means the fallback is always correct for
     whatever `currentLang` actually is. */
  var svcListIcons = {};
  ['full','normal'].forEach(function(svc){
    var ul = document.querySelector('.svc-card[data-svc="'+svc+'"] .svc-list');
    if(!ul) return;
    svcListIcons[svc] = Array.prototype.map.call(ul.querySelectorAll('li > svg'), function(sv){ return sv.outerHTML; });
  });
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg>';
  function escHtml(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function renderFeatureList(ul, svc, items){
    var icons = svcListIcons[svc] || [];
    ul.innerHTML = items.map(function(item, i){
      return '<li>' + (icons[i] || CHECK_SVG) + '<div><span>' + escHtml(item.main) + '</span>'
           + (item.sub ? '<span class="count">' + escHtml(item.sub) + '</span>' : '') + '</div></li>';
    }).join('');
  }
  // I18N's own built-in list for the given service, in the current
  // language -- fullLi1..fullLi8(+fullLi8c) / normalLi1..normalLi5.
  function builtinFeatureItems(svc){
    var n = svc === 'full' ? 8 : 5;
    var items = [];
    for(var i = 1; i <= n; i++){
      var main = T(svc + 'Li' + i);
      if(!main) continue;
      items.push({ main: main, sub: T(svc + 'Li' + i + 'c') });
    }
    return items;
  }
  function applyFeatureLists(){
    var per = (LCFG.features || {})[currentLang] || {};
    ['full','normal'].forEach(function(svc){
      var ul = document.querySelector('.svc-card[data-svc="'+svc+'"] .svc-list');
      if(!ul) return;
      var raw = per[svc];
      var lines = (typeof raw === 'string') ? raw.split('\n').map(function(l){ return l.trim(); }).filter(Boolean) : [];
      if(!lines.length){
        renderFeatureList(ul, svc, builtinFeatureItems(svc));
        return;
      }
      var items = lines.map(function(line){
        var parts = line.split('|');
        return { main: parts[0].trim(), sub: parts.length > 1 ? parts.slice(1).join('|').trim() : '' };
      });
      renderFeatureList(ul, svc, items);
    });
  }

  /* The "call" and "visit" trust cards, entirely JS-rendered -- see the
     comment in cardiagnos-landing.liquid's Trust section for why: they
     have to be genuinely per-language (a Swedish visitor sees Sweden's
     phone/address, a Saudi visitor sees Saudi's, since Cardiagnos is a
     Swedish business now also serving Saudi Arabia), and the language
     switcher runs client-side with no page reload, so anything baked in
     once at server-render time would never update on a later switch. Runs
     on the same schedule as applyFeatureLists -- page load and every
     language switch. `reveal in` (not just `reveal`) on cards added after
     the initial load: the scroll fade-in only ever plays for elements the
     IntersectionObserver was watching at scroll time, so a card inserted
     later would sit at opacity:0 forever without it -- these should just
     be visible immediately, matching the already-settled state of the
     rest of the section by the time a language switch can happen. */
  var TRUST_PHONE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6.6 10.8a15.7 15.7 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11 11 0 0 0 3.4.55 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11 11 0 0 0 .55 3.4 1 1 0 0 1-.25 1z"/></svg>';
  var TRUST_PIN_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s7-6.1 7-11.5A7 7 0 0 0 5 9.5C5 14.9 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.4"/></svg>';
  function applyTrustContactCards(){
    var mount = document.getElementById('trustContactCards');
    if(!mount) return;
    var phone = (T('trustPhone') || '').trim();
    var address = (T('trustAddress') || '').trim();
    var html = '';
    if(phone){
      html += '<div class="trust-card reveal in">'
        + '<div class="trust-icon">' + TRUST_PHONE_ICON + '</div>'
        + '<h3>' + escHtml(T('trustCallTitle')) + '</h3>'
        + '<p>' + escHtml(T('trustCallDesc')) + '</p>'
        + '<a class="trust-detail mono" href="tel:' + escHtml(phone.replace(/[\s-]/g, '')) + '" dir="ltr">' + escHtml(phone) + '</a>'
        + '</div>';
    }
    if(address){
      html += '<div class="trust-card reveal in">'
        + '<div class="trust-icon">' + TRUST_PIN_ICON + '</div>'
        + '<h3>' + escHtml(T('trustVisitTitle')) + '</h3>'
        + '<p>' + escHtml(T('trustVisitDesc')) + '</p>'
        + '<div class="trust-detail">' + escHtml(address) + '</div>'
        + '</div>';
    }
    mount.innerHTML = html;
  }

  function applyTranslations(){
    document.querySelectorAll('[data-i18n]').forEach(function(el){
      var key = el.getAttribute('data-i18n');
      var val = T(key);
      if(val) el.textContent = val;
    });
    document.querySelectorAll('[data-i18n-html]').forEach(function(el){
      var key = el.getAttribute('data-i18n-html');
      var val = T(key);
      if(val) el.innerHTML = val;
    });
    renderThanksP2();
    // After applyTranslations so the rebuilt <li>s (which deliberately carry
    // no data-i18n attributes) are never overwritten by it.
    applyFeatureLists();
    applyTrustContactCards();
  }

  var LANGS = ['en','sv','ar'];
  /* Pushes the chosen site language into Shopify's own session locale (via
     the hidden 'localization' form) so checkout, and Shopify's automatic
     order-confirmation email, come out in that language -- not whatever the
     URL/geo landed the visitor in. Background fetch, no reload: the page
     stays client-side-translated, only the server cookie changes, and the
     next navigation (to checkout) picks it up. No-ops when already in sync. */
  var appliedLocale = (LCFG.storefrontLocale || 'en');
  function syncStorefrontLocale(){
    if(currentLang === appliedLocale) return;
    var form = document.getElementById('CardiagnosLocaleForm') || document.getElementById('CardiagnosCountryForm');
    var input = document.getElementById('cardiagnosLocaleCode');
    if(!form || !input) return;
    input.value = currentLang;
    appliedLocale = currentLang;
    try{
      fetch(form.getAttribute('action') || '/localization', {
        method: 'POST', credentials: 'same-origin', body: new FormData(form),
        headers: { 'Accept': 'text/html' }
      }).catch(function(){});
    }catch(e){}
  }

  function setLang(lang){
    currentLang = (LANGS.indexOf(lang) !== -1) ? lang : 'en';
    try { localStorage.setItem(LANG_KEY, currentLang); } catch(e){}
    // Keep the address in step (/ar, /sv, none for English) so a reload
    // doesn't switch back to the language in the old URL.
    try{ var _p = location.pathname.replace(/^\/(ar|sv|en)(?=\/|$)/, ''); if(_p === '/') _p = ''; history.replaceState(null, '', (currentLang === 'en' ? '' : '/' + currentLang) + (_p || (currentLang === 'en' ? '/' : '')) + location.search + location.hash); }catch(e){}
    var root = document.querySelector('.cardiagnos-landing-root');
    if(root){
      root.setAttribute('dir', currentLang === 'ar' ? 'rtl' : 'ltr');
      root.setAttribute('lang', currentLang);
    }
    document.querySelectorAll('[data-lang-opt]').forEach(function(el){
      var on = el.getAttribute('data-lang-opt') === currentLang;
      el.classList.toggle('active', on);
      if(el.tagName === 'BUTTON') el.setAttribute('aria-pressed', String(on));
    });
    // The "New to Saudi Arabia -- verify us before you pay" trust block is a
    // Saudi-market reassurance; Swedish visitors (the established home
    // market) don't need it.
    var trustSec = document.getElementById('trust');
    if(trustSec) trustSec.style.display = (currentLang === 'sv') ? 'none' : '';
    applyTranslations();
    syncStorefrontLocale();
    if(typeof syncReportLangOptions === 'function') syncReportLangOptions();
    if(typeof syncLocationFields === 'function') syncLocationFields();
    if(typeof refreshDemoPricing === 'function') refreshDemoPricing();
    if(typeof syncContactField === 'function') syncContactField();
    if(typeof syncVehiclePlaceholders === 'function') syncVehiclePlaceholders();
    if(typeof syncLandingVideos === 'function') syncLandingVideos();
    syncSampleReport();
  }

  // Sample report button in the hero opens the online report viewer (same
  // page customers get -- tap a photo/video for a popup, PDF downloadable
  // from its top bar). Arabic visitors get the Arabic sample, everyone else
  // the English one (there's no Swedish sample yet).
  var SAMPLE_REPORTS = {
    ar: '/pages/report?t=SampleReportRS7Arabic',
    en: '/pages/report?t=SampleReportRS7English'
  };
  function syncSampleReport(){
    var a = document.getElementById('heroSample');
    if(a) a.setAttribute('href', SAMPLE_REPORTS[currentLang] || SAMPLE_REPORTS.en);
  }

  // The two landing-page videos (hero + side-strip) have Swedish- and
  // English-specific cuts -- see data-sv-src/data-en-src on each <video> in
  // cardiagnos-landing.liquid. Arabic keeps the original data-default-src.
  // Swapping src needs an explicit .load() (changing the attribute alone
  // doesn't make an already-playing <video> pick up the new source) and a
  // fresh .play() since loading resets it to paused.
  function syncLandingVideos(){
    document.querySelectorAll('video[data-sv-src]').forEach(function(v){
      var attr = (currentLang === 'sv') ? 'data-sv-src' : (currentLang === 'en') ? 'data-en-src' : 'data-default-src';
      var want = v.getAttribute(attr) || v.getAttribute('data-default-src');
      if(!want || v.getAttribute('src') === want) return;
      v.setAttribute('src', want);
      v.load();
      var p = v.play();
      if(p && p.catch) p.catch(function(){});
    });
  }

  function syncVehiclePlaceholders(){
    var makeEl = document.getElementById('vehicleMakeInput');
    var modelEl = document.getElementById('vehicleModelInput');
    var yearEl = document.getElementById('vehicleYearInput');
    var notesEl = document.getElementById('customerNotesInput');
    if(makeEl) makeEl.placeholder = T('vehicleMakePh');
    if(modelEl) modelEl.placeholder = T('vehicleModelPh');
    if(yearEl) yearEl.placeholder = T('vehicleYearPh');
    if(notesEl) notesEl.placeholder = T('customerNotesPh');
  }

  /* Each flag selects its own language directly. This used to be a single
     button that CYCLED to the next language, which was tolerable with EN/AR
     text labels but plainly wrong with flags -- clicking the English flag
     advanced to the next language instead of switching to English. */
  document.querySelectorAll('[data-lang-opt]').forEach(function(el){
    el.addEventListener('click', function(){
      setLang(el.getAttribute('data-lang-opt'));
    });
  });
  setLang(currentLang);

  // real 3D model viewer (Three.js + OrbitControls)
  (function(){
    var wrap = document.getElementById('car3dWrap');
    var loadingEl = document.getElementById('car3dLoading');
    var hintEl = document.getElementById('dragHint');

    function showError(msg){
      if(!loadingEl) return;
      loadingEl.classList.remove('hide');
      var ring = loadingEl.querySelector('.car3d-ring');
      if(ring) ring.style.display = 'none';
      var lbl = loadingEl.querySelector('.lbl');
      if(lbl){
        lbl.style.whiteSpace = 'pre-wrap';
        lbl.style.textAlign = 'center';
        lbl.style.maxWidth = '90%';
        lbl.style.fontSize = '10px';
        lbl.textContent = '3D PREVIEW ERROR:\n' + msg;
      }
    }

    function init(){
     try {
      if(typeof THREE === 'undefined') throw new Error('THREE is undefined (core lib did not load)');
      if(!THREE.GLTFLoader) throw new Error('THREE.GLTFLoader missing (loader script did not attach)');
      if(!THREE.OrbitControls) throw new Error('THREE.OrbitControls missing (controls script did not attach)');

      var width = wrap.clientWidth, height = wrap.clientHeight;
      if(!width || !height) throw new Error('car3dWrap has zero size (w=' + width + ' h=' + height + ')');

      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(30, width/height, 0.01, 100);
      camera.position.set(0.62, 0.4, 0.92);

      var renderer = new THREE.WebGLRenderer({ antialias:true, alpha:true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.setSize(width, height);
      if('outputEncoding' in renderer) renderer.outputEncoding = THREE.sRGBEncoding;
      // The env map below reflects real HDR highlights into the metallic
      // body paint; without tone mapping those reflections clip per-channel
      // at different points and show up as red/yellow fringing at panel
      // edges. Reinhard is a gentler curve than ACES and needed far less
      // exposure compensation to stay close to the original look. This
      // (and the exposure) must be set here, before any material/shader in
      // this scene is ever compiled -- toggling it on live later doesn't
      // reliably force a recompile in this Three.js build.
      if('toneMapping' in renderer){
        renderer.toneMapping = THREE.ReinhardToneMapping;
        renderer.toneMappingExposure = 1.6;
      }
      wrap.appendChild(renderer.domElement);

      // Lower than the pre-HDRI values: with the 1.6x Reinhard exposure
      // boost, the old flat light intensities wash out the env map's own
      // gradient into a flat white blob instead of showing paint depth.
      scene.add(new THREE.HemisphereLight(0x8fb4ff, 0x0a0e18, 0.25));
      var key = new THREE.DirectionalLight(0xffffff, 0.5); key.position.set(2, 3, 2); scene.add(key);
      var rim = new THREE.DirectionalLight(0x4fe3ff, 0.35); rim.position.set(-2, 1.2, -2.2); scene.add(rim);
      scene.add(new THREE.AmbientLight(0x223355, 0.08));

      // A metallic PBR surface with no environment map has nothing to
      // reflect except the few lights above -- flat color alone reads as
      // lifeless rather than like real car paint. A real CC0 studio HDRI
      // (Poly Haven "studio_small_08", 1k, hosted as a theme asset) gives
      // the body genuine directional highlights/gradients to reflect.
      if(THREE.RGBELoader){
        var pmrem = new THREE.PMREMGenerator(renderer);
        pmrem.compileEquirectangularShader();
        var hdriUrl = wrap.getAttribute('data-hdri-url');
        if(hdriUrl){
          // This build's RGBELoader only supports Float/HalfFloatType
          // (UnsignedByteType logs "unsupported type" and fails silently)
          // -- its own default (HalfFloatType) is fine for PMREM input.
          new THREE.RGBELoader()
            .load(hdriUrl, function(hdrTex){
              scene.environment = pmrem.fromEquirectangular(hdrTex).texture;
              hdrTex.dispose();
              pmrem.dispose();
            });
        }
      }

      // A flat RingGeometry lying on the ground reads fine from directly
      // above, but from this camera's elevated 3/4 angle its near/far arcs
      // (facing the camera) show their full width while the left/right arcs
      // are seen almost edge-on -- a 2D disc has zero thickness there, so
      // those sides visually thin out to nearly nothing and the ring reads
      // as broken rather than a complete circle. TorusGeometry is a real 3D
      // tube instead of a flat disc, so it keeps a visible cross-section
      // from every angle, including side-on -- same footprint and rotation
      // as before, just genuinely whole from this viewpoint.
      var ring = new THREE.Mesh(
        new THREE.TorusGeometry(0.65, 0.05, 12, 64),
        new THREE.MeshBasicMaterial({ color:0x4fe3ff, transparent:true, opacity:0.35, side:THREE.DoubleSide })
      );
      ring.rotation.x = -Math.PI/2;
      ring.position.y = -0.3;
      scene.add(ring);

      var controls = new THREE.OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.dampingFactor = 0.08;
      controls.enablePan = false;
      // The mouse wheel/trackpad scroll over this canvas is how a visitor
      // scrolls the REST of the page too -- OrbitControls' default zoom
      // hijacks that scroll gesture the instant the cursor happens to be
      // over the 3D viewer, which reads as the page "getting stuck" zooming
      // the car instead of scrolling. Disabling zoom entirely (rotate-only)
      // keeps normal page scroll working everywhere, including over the
      // model.
      controls.enableZoom = false;
      controls.minDistance = 0.5;
      controls.maxDistance = 2.4;
      controls.minPolarAngle = Math.PI * 0.15;
      controls.maxPolarAngle = Math.PI * 0.62;
      controls.autoRotate = true;
      controls.autoRotateSpeed = 1.3;
      controls.target.set(0, 0, 0);

      var loader = new THREE.GLTFLoader();
      var modelUrl = wrap.getAttribute('data-model-url');
      if(!modelUrl) throw new Error('data-model-url attribute missing on car3dWrap');

      loader.load(modelUrl, function(gltf){
        try {
          var model = gltf.scene;
          var box = new THREE.Box3().setFromObject(model);
          var size = new THREE.Vector3(); box.getSize(size);
          var center = new THREE.Vector3(); box.getCenter(center);
          var maxDim = Math.max(size.x, size.y, size.z) || 1;
          var scale = 1 / maxDim;
          model.scale.setScalar(scale);
          model.position.set(-center.x*scale, -center.y*scale, -center.z*scale);
          scene.add(model);

          // The old atlas-baked model needed the material-reconstruction
          // pass that used to live here (its "Atlas_Body" etc. materials
          // carried broken baked data). The current model
          // (audi-rs7-final-doors-realmats-compressed.glb, shared with the
          // inspector app page) exports its REAL Blender materials directly
          // -- silver "Car Paint.001" with a genuine glTF clearcoat
          // extension, real glass transmission, etc. -- so overriding them
          // here would only strip that clearcoat back down to a flat
          // MeshStandardMaterial. Nothing to do for materials now; removed.

          var sx = size.x*scale, sy = size.y*scale, sz = size.z*scale;
          var radius = 0.5 * Math.sqrt(sx*sx + sy*sy + sz*sz);
          var vFov = camera.fov * Math.PI/180;
          var hFov = 2 * Math.atan(Math.tan(vFov/2) * camera.aspect);
          var fitDist = Math.max(radius/Math.sin(vFov/2), radius/Math.sin(hFov/2)) * 1.4;

          var dir = new THREE.Vector3(0.62, 0.32, 0.92).normalize();
          camera.position.copy(dir.multiplyScalar(fitDist));
          camera.near = fitDist/100; camera.far = fitDist*20; camera.updateProjectionMatrix();
          controls.target.set(0, 0, 0);
          controls.update();

          // The ring used to be sized off the car's radius alone (radius*2.2)
          // with no reference to what the camera actually shows -- for a
          // typical car's proportions that works out to just about exactly
          // the distance fitDist frames to the viewport edge (a "radius*1.4"
          // sphere, by construction of fitDist below), so the ring's own
          // outer edge landed right at the frame boundary with essentially
          // no margin -- any perspective distortion from viewing a flat ring
          // at this angle was enough to push its near/far arcs past the
          // edge and get clipped by the canvas. Deriving the ring's size
          // directly from the same framed-radius math the camera itself
          // uses (rather than a separate guessed multiplier) guarantees a
          // real, predictable margin regardless of a given model's own
          // proportions.
          var framedRadius = radius * 1.4; // sphere that exactly touches the viewport edge at fitDist
          var ringOuterLocal = 0.65 + 0.05; // TorusGeometry(0.65, 0.05, ...)'s own outer radius
          ring.scale.setScalar((framedRadius * 0.72) / ringOuterLocal);
          ring.position.y = -sy/2 - 0.02;

          // ---- tap the car to open hood + trunk + all 4 doors ----
          // Same system as cardiagnos-app-inspector.js's Home screen
          // (that file has the full writeup on why doors need a
          // quaternion/world-axis tween and hood/trunk a plain local
          // rotation.x tween -- ported here essentially unchanged since
          // this is the same model with the same node names).
          var panelState = {};
          function setupPanel(key, nodeName, openDeltaX){
            var node = model.getObjectByName(nodeName);
            if(!node) return;
            panelState[key] = { node: node, restX: node.rotation.x, openX: node.rotation.x + openDeltaX, isOpen: false, tween: null };
          }
          setupPanel('hood', 'Empty007', -1.1);
          setupPanel('trunk', 'Empty002', 1.0);
          function tweenPanel(key, open, durationMs){
            var p = panelState[key];
            if(!p || p.isOpen === open) return;
            p.tween = { fromX: p.node.rotation.x, toX: open ? p.openX : p.restX, start: performance.now(), duration: durationMs || 900 };
            p.isOpen = open;
          }

          var doorState = {};
          function setupDoor(key, nodeName, openAngleDeg){
            var node = model.getObjectByName(nodeName);
            if(!node) return;
            var restQuat = node.quaternion.clone();
            var openQuat = restQuat.clone();
            var deltaQuat = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0,1,0), openAngleDeg * Math.PI/180);
            openQuat.premultiply(deltaQuat);
            doorState[key] = { node: node, restQuat: restQuat, openQuat: openQuat, isOpen: false, tween: null };
          }
          setupDoor('door_lf', 'DOOR_LF', -68);
          setupDoor('door_lr', 'DOOR_LR', -68);
          setupDoor('door_rf', 'DOOR_RF', 68);
          setupDoor('door_rr', 'DOOR_RR', 68);
          function tweenDoor(key, open, durationMs){
            var p = doorState[key];
            if(!p || p.isOpen === open) return;
            p.tween = { fromQuat: p.node.quaternion.clone(), toQuat: open ? p.openQuat : p.restQuat, start: performance.now(), duration: durationMs || 900 };
            p.isOpen = open;
          }

          function easeOutCubic(t){ return 1 - Math.pow(1-t, 3); }
          function panelsOrDoorsBusy(){
            var busy = false;
            Object.keys(panelState).forEach(function(k){ if(panelState[k].tween) busy = true; });
            Object.keys(doorState).forEach(function(k){ if(doorState[k].tween) busy = true; });
            return busy;
          }
          renderer.domElement.addEventListener('click', function(){
            if(panelsOrDoorsBusy()) return;
            var opening = !panelState.hood || !panelState.hood.isOpen;
            tweenPanel('hood', opening, 900);
            tweenPanel('trunk', opening, 900);
            Object.keys(doorState).forEach(function(k){ tweenDoor(k, opening, 900); });
          });
          window.__ciLandingAnimatePanels = function(){
            Object.keys(panelState).forEach(function(key){
              var p = panelState[key];
              if(!p.tween) return;
              var pt = Math.min(1, (performance.now() - p.tween.start) / p.tween.duration);
              var pe = easeOutCubic(pt);
              p.node.rotation.x = p.tween.fromX + (p.tween.toX - p.tween.fromX) * pe;
              if(pt >= 1) p.tween = null;
            });
            Object.keys(doorState).forEach(function(key){
              var p = doorState[key];
              if(!p.tween) return;
              var pt = Math.min(1, (performance.now() - p.tween.start) / p.tween.duration);
              var pe = easeOutCubic(pt);
              p.node.quaternion.slerpQuaternions(p.tween.fromQuat, p.tween.toQuat, pe);
              if(pt >= 1) p.tween = null;
            });
          };

          loadingEl.classList.add('hide');
          hintEl.style.transition = 'opacity .6s ease';
          hintEl.style.opacity = '1';
          renderer.domElement.addEventListener('pointerdown', function(){ controls.autoRotate = false; }, { once:true });
          setTimeout(function(){ hintEl.style.opacity = '0'; }, 6500);
        } catch(err2){
          showError('post-load: ' + (err2 && (err2.message || err2)));
        }
      }, undefined, function(err){
        showError('load failed: ' + (err && (err.message || err)));
      });

      function animate(){
        requestAnimationFrame(animate);
        controls.update();
        if(window.__ciLandingAnimatePanels) window.__ciLandingAnimatePanels();
        renderer.render(scene, camera);
      }
      animate();

      window.addEventListener('resize', function(){
        var w = wrap.clientWidth, h = wrap.clientHeight;
        if(!w || !h) return;
        camera.aspect = w/h; camera.updateProjectionMatrix();
        renderer.setSize(w, h);
      });
     } catch(err){
      showError((err && (err.message || err)) || 'unknown error');
     }
    }

    // The wrap's CSS size (min(460px,88vw) etc.) is sometimes not yet laid
    // out the instant this deferred script runs -- e.g. while web fonts are
    // still swapping in and reflowing the hero. Poll across a few animation
    // frames before giving up, instead of failing on the very first read.
    function waitForSize(triesLeft){
      if(!wrap){ showError('car3dWrap element missing'); return; }
      if((wrap.clientWidth && wrap.clientHeight) || triesLeft <= 0){ init(); return; }
      requestAnimationFrame(function(){ waitForSize(triesLeft - 1); });
    }
    waitForSize(90);
  })();

  // 3d tilt on service cards
  document.querySelectorAll('[data-tilt]').forEach(function(card){
    card.addEventListener('mousemove', function(e){
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      var rx = (y - .5) * -8;
      var ry = (x - .5) * 10;
      card.style.transform = 'rotateX('+rx+'deg) rotateY('+ry+'deg) translateY(-2px)';
      card.style.setProperty('--mx', (x*100)+'%');
      card.style.setProperty('--my', (y*100)+'%');
    });
    card.addEventListener('mouseleave', function(){
      card.style.transform = 'rotateX(0) rotateY(0)';
    });
  });

  // demo state
  /* Prices come from the theme settings so the booking panel, the service
     cards and the Shopify product can be kept in sync from one place. The
     booking panel used to hardcode 180 for Normal while the service card
     said 200 and checkout actually charged 200 -- binding both to the same
     setting is what stops those drifting apart again. */
  /* svcData now holds the REAL Shopify price (minor units + currency code),
     sourced server-side in cardiagnos-landing.liquid from the live product
     variant -- not the theme-setting text field a merchant could type
     anything into with nothing tying it to what checkout actually charges
     (see the price-drift comment this used to carry). cfgPrice is kept only
     as a last-resort fallback for the rare case the product lookup itself
     fails (wrong handle, product unpublished, etc). */
  function cfgPrice(key, fallback){
    var v = parseFloat((LCFG.prices || {})[key] && (LCFG.prices[key].amount != null ? LCFG.prices[key].amount / 100 : LCFG.prices[key]));
    return isFinite(v) && v > 0 ? v : fallback;
  }
  function cfgPriceEntry(key, fallbackAmount, fallbackCurrency){
    var raw = (LCFG.prices || {})[key];
    if(raw && typeof raw === 'object' && isFinite(raw.amount) && raw.amount > 0){
      return { amount: raw.amount, currency: raw.currency || fallbackCurrency };
    }
    return { amount: fallbackAmount, currency: fallbackCurrency };
  }
  var svcData = {
    full:   cfgPriceEntry('full', 40000, 'SAR'),
    normal: cfgPriceEntry('normal', 20000, 'SAR'),
  };
  // reportLang starts matching whichever language the page itself is
  // showing (the common case), but is its own independent choice from
  // there -- a customer using the Arabic site can still ask for an
  // English report, or vice versa, via the report-language toggle below.
  var state = { svc:'full', pref:'whatsapp', phone:'', email:'', vehicleMake:'', vehicleModel:'', vehicleYear:'', reportLang: currentLang, notes:'', country:'', city:'' };
  // Sticks once the customer has clicked a report-language button
  // themselves (see the click handler below) -- before that, reportLang is
  // just a DEFAULT that should keep following whichever language the site
  // itself switches to (see syncReportLangOptions), not a genuine choice
  // yet.
  var reportLangExplicit = false;

  /* ---------- currency follows the COUNTRY chosen for the inspection ----------
     Not the site language: an English-mode visitor can book in either
     country, and their choice there is what determines currency -- the site
     language only pre-fills it for Swedish (always Sweden) and Arabic
     (always Saudi Arabia). Switching country submits Shopify's own native
     'localization' form (see the hidden #CardiagnosCountryForm in
     cardiagnos-landing.liquid) -- the same mechanism the theme's own
     header/footer country picker uses -- which sets the buyer's MARKET for
     this session server-side. Checkout then charges whatever price that
     market has set for this product in Shopify admin; nothing here invents
     a converted number of its own. */
  /* Official Saudi Riyal symbol (SAMA/Unicode 17.0, U+20C1 -- approved Feb
     2025, only added to Unicode in September 2025), embedded as the actual
     CC0 vector artwork rather than the Unicode character: at barely a year
     old, most phones don't have a font that renders U+20C1 yet and would
     show a blank box exactly where the price should be. Source: Wikimedia
     Commons, File:Saudi_Riyal_Symbol.svg (CC0/public domain). fill is
     currentColor so it always matches the surrounding text colour. */
  var SAR_ICON_SVG = '<svg class="sar-icon" viewBox="0 0 1124.14 1256.39" aria-hidden="true" focusable="false"><path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>';

  /* The customer's OWN country pick, made while browsing in English --
     independent of state.country, which sv/ar happily overwrite every time
     the language changes (LANG_COUNTRY auto-assign, just below). Without a
     separate variable for this, switching English -> Sweden -> Arabic ->
     English forgets the Sweden pick the instant Arabic mode's auto-assign
     stomps on state.country, because by the time English mode looks again
     there is nothing left distinguishing "the customer chose this" from
     "Arabic mode happened to leave this behind". This is the one thing
     English mode consults to rebuild state.country on every return to it,
     so a detour through the other two languages can never erase it -- only
     the customer's own change on the dropdown (or clearing it back to the
     placeholder) ever does. null means "never chosen yet", not merely
     "not showing right now". */
  var explicitEnglishCountry = null;

  var COUNTRY_CURRENCY = { SE:'SEK', SA:'SAR' };
  var marketSwitchToken = 0;
  var marketReady = Promise.resolve();
  var lastSwitchedCountry = null;

  function formatMoney(amountMinorUnits, currencyCode, locale){
    if(!isFinite(amountMinorUnits)) return '';
    try{
      return new Intl.NumberFormat(locale || 'en', { style:'currency', currency: currencyCode || 'SAR', currencyDisplay:'symbol' })
        .format(amountMinorUnits / 100);
    }catch(e){
      return (amountMinorUnits / 100).toFixed(2) + ' ' + (currencyCode || '');
    }
  }

  /* Paints a price into an element, swapping in the real SAR icon exactly
     where Intl would have put the currency token -- formatToParts (not
     string concatenation) is what lets this reuse Intl's own correct
     prefix/suffix placement and spacing per locale ("SAR 400.00" in
     English, "٤٠٠٫٠٠ [icon]" in Arabic) instead of hand-guessing it. Every
     other currency (just SEK today) keeps plain text -- krona's own symbol
     renders fine everywhere already, no icon needed. */
  function renderPrice(el, amountMinorUnits, currencyCode, locale){
    if(!el || !isFinite(amountMinorUnits)) return;
    var code = currencyCode || 'SAR';
    var fmt;
    try{
      fmt = new Intl.NumberFormat(locale || 'en', { style:'currency', currency: code, currencyDisplay:'symbol' });
    }catch(e){ el.textContent = formatMoney(amountMinorUnits, code, locale); return; }
    var parts;
    try{ parts = fmt.formatToParts(amountMinorUnits / 100); }
    catch(e){ el.textContent = formatMoney(amountMinorUnits, code, locale); return; }
    if(code === 'SAR'){
      el.innerHTML = parts.map(function(part){
        return part.type === 'currency' ? SAR_ICON_SVG : escHtml(part.value);
      }).join('');
      el.classList.add('has-sar-icon');
    } else {
      el.textContent = parts.map(function(part){ return part.value; }).join('');
      el.classList.remove('has-sar-icon');
    }
  }

  function setPricingBusy(busy){
    ['paySvcPrice','payTotal','demoMiniPriceFull','demoMiniPriceNormal'].forEach(function(id){
      var el = document.getElementById(id);
      if(el) el.classList.toggle('price-updating', !!busy);
    });
  }

  /* Re-reads this product's price for whatever market the buyer is now in.
     Shopify's product '.js' endpoint is session/market-aware -- it returns
     whatever price the ACTIVE market has for each variant, the same way the
     storefront's own price display would -- provided the localization
     cookie from switchMarketForCountry has already been set. Fails soft: if
     the fetch fails, or the market/price genuinely doesn't exist yet for
     this product (e.g. Sweden market not created, or created but this
     product not priced for it), the last known good price stays on screen
     rather than showing something broken or fabricated. */
  function fetchLiveProductPrices(currencyCode){
    var url = LCFG.bookingProductUrl;
    if(!url) return Promise.resolve();
    return fetch(url + '.js', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        if(!data || !data.variants) return;
        data.variants.forEach(function(v){
          if(!v || !isFinite(v.price)) return;
          if(String(v.id) === String(VARIANT_IDS.full))   svcData.full   = { amount: v.price, currency: currencyCode };
          if(String(v.id) === String(VARIANT_IDS.normal)) svcData.normal = { amount: v.price, currency: currencyCode };
        });
      })
      .catch(function(){ /* keep the last known prices */ });
  }

  function switchMarketForCountry(code){
    if(!code || code === lastSwitchedCountry) return marketReady;
    lastSwitchedCountry = code;
    var token = ++marketSwitchToken;
    var form = document.getElementById('CardiagnosCountryForm');
    var input = document.getElementById('cardiagnosCountryCode');
    if(!form || !input){ return marketReady = Promise.resolve(); }
    input.value = code;
    setPricingBusy(true);
    marketReady = fetch(form.getAttribute('action') || window.location.pathname, {
      method:'POST', credentials:'same-origin', body: new FormData(form)
    }).then(function(){
      if(token !== marketSwitchToken) return;
      return fetchLiveProductPrices(COUNTRY_CURRENCY[code] || svcData.full.currency);
    }).then(function(){
      if(token !== marketSwitchToken) return;
      setPricingBusy(false);
      if(typeof refreshDemoPricing === 'function') refreshDemoPricing();
    }).catch(function(){
      if(token === marketSwitchToken) setPricingBusy(false);
    });
    return marketReady;
  }

  function currentContact(){
    return state.pref === 'whatsapp' ? state.phone : state.email;
  }

  function isValidContact(){
    var v = (currentContact() || '').trim();
    if(state.pref === 'whatsapp'){
      var digits = v.replace(/[^0-9]/g, '');
      return /^\+?[0-9\s-]{7,}$/.test(v) && digits.length >= 8;
    }
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function syncContactField(){
    if(typeof state === 'undefined' || !state) return;
    var input = document.getElementById('contactInput');
    var label = document.getElementById('contactLabel');
    if(!input || !label) return;
    if(state.pref === 'whatsapp'){
      input.type = 'tel'; input.inputMode = 'tel'; input.autocomplete = 'off';
      input.placeholder = T('contactPlaceholderWhatsapp');
      label.textContent = T('contactLabelWhatsapp');
      input.value = state.phone;
    } else {
      input.type = 'email'; input.inputMode = 'email'; input.autocomplete = 'off';
      input.placeholder = T('contactPlaceholderEmail');
      label.textContent = T('contactLabelEmail');
      input.value = state.email;
    }
    input.classList.remove('invalid');
    var err = document.getElementById('contactError');
    if(err) err.style.display = 'none';
  }

  function refreshDemoPricing(){
    if(typeof state === 'undefined' || !state || !svcData[state.svc]) return;
    var s = svcData[state.svc];
    /* The digit SCRIPT/formatting follows the language the customer is
       actually reading (currentLang) -- NOT the country they picked. Those
       are independent: an English-mode visitor who selects Saudi Arabia as
       their country should see '400.00', not Eastern Arabic-Indic digits,
       even though the CURRENCY that choice implies (SAR, via
       COUNTRY_CURRENCY) is completely correct either way. Conflating the
       two here previously showed Arabic numerals to an English-reading
       customer the moment they picked Saudi Arabia. */
    var priceLocale = currentLang === 'ar' ? 'ar' : currentLang === 'sv' ? 'sv' : 'en';
    document.getElementById('paySvcName').textContent = T(state.svc);
    renderPrice(document.getElementById('paySvcPrice'), s.amount, s.currency, priceLocale);
    renderPrice(document.getElementById('payTotal'),    s.amount, s.currency, priceLocale);
    renderPrice(document.getElementById('demoMiniPriceFull'),   svcData.full.amount,   svcData.full.currency,   priceLocale);
    renderPrice(document.getElementById('demoMiniPriceNormal'), svcData.normal.amount, svcData.normal.currency, priceLocale);
    // The two big service cards up top -- the FIRST price a visitor sees on
    // the page, previously static theme-setting text nobody wired up
    // (see cardiagnos-landing.liquid's svc-price divs). Same formatMoney
    // source of truth as the booking widget, so every number on the page
    // agrees with the real per-market price rather than just some of them.
    renderPrice(document.getElementById('svcPriceFull'),   svcData.full.amount,   svcData.full.currency,   priceLocale);
    renderPrice(document.getElementById('svcPriceNormal'), svcData.normal.amount, svcData.normal.currency, priceLocale);
    document.getElementById('payPref').textContent = state.pref === 'whatsapp' ? T('whatsapp') : T('email');
    var payContactEl = document.getElementById('payContact');
    if(payContactEl) payContactEl.textContent = currentContact();
    var payLocEl = document.getElementById('payLocation');
    var payLocRow = document.getElementById('payLocationRow');
    if(payLocEl) payLocEl.textContent = locationLabel();
    if(payLocRow) payLocRow.style.display = state.city ? '' : 'none';
    var chanEl = document.getElementById('thanksChannel');
    if(chanEl) chanEl.textContent = state.pref === 'whatsapp' ? T('whatsapp') : T('email');

    var deliveryLabel = state.pref === 'whatsapp' ? 'WhatsApp' : 'Email';
    // The customer's own report-language choice, not the site UI language
    // -- see the reportLang comment on state's definition above.
    var languageLabel = state.reportLang === 'ar' ? 'Arabic' : state.reportLang === 'sv' ? 'Swedish' : 'English';
    var contactValue = currentContact();
    document.querySelectorAll('.express-checkout-btn').forEach(function(box){
      var match = box.getAttribute('data-express-svc') === state.svc;
      box.style.display = match ? 'block' : 'none';
      if(match){
        var prefInput = box.querySelector('.js-pref-input');
        var langInput = box.querySelector('.js-lang-input');
        var contactInput = box.querySelector('.js-contact-input');
        var vehicleMakeInput = box.querySelector('.js-vehicle-make-input');
        var vehicleModelInput = box.querySelector('.js-vehicle-model-input');
        var vehicleYearInput = box.querySelector('.js-vehicle-year-input');
        var notesInput = box.querySelector('.js-notes-input');
        var countryInput = box.querySelector('.js-country-input');
        var cityInput = box.querySelector('.js-city-input');
        if(prefInput) prefInput.value = deliveryLabel;
        if(langInput) langInput.value = languageLabel;
        if(contactInput) contactInput.value = contactValue;
        if(vehicleMakeInput) vehicleMakeInput.value = state.vehicleMake || '';
        if(vehicleModelInput) vehicleModelInput.value = state.vehicleModel || '';
        if(vehicleYearInput) vehicleYearInput.value = state.vehicleYear || '';
        if(notesInput) notesInput.value = state.notes || '';
        if(countryInput) countryInput.value = state.country ? T(state.country === 'SA' ? 'countrySA' : 'countrySE') : '';
        if(cityInput) cityInput.value = state.city || '';
      }
    });
  }


  /* ---------- inspection location (country + city) ----------
     The city list follows the SITE language, not the report language:
     Swedish visitors are offered Swedish cities, Arabic visitors Saudi
     cities, and English visitors -- who could be either -- pick the
     country first and then get that country's cities. The lists
     themselves come from the theme editor (see the section schema's
     "Inspection cities" settings), one city per line, so coverage can be
     extended later without touching this file. */
  var LANG_COUNTRY = { sv:'SE', ar:'SA' };
  function citiesFor(code){
    /* Saudi cities are held as two parallel lists so an Arabic visitor sees
       them in Arabic while an English visitor who picks Saudi Arabia sees
       them in Latin. Swedish place names are spelled the same either way,
       so Sweden needs only the one list. */
    var c = LCFG.cities || {};
    var raw = (code === 'SA')
      ? (currentLang === 'ar' ? (c.SA_ar || c.SA_en) : (c.SA_en || c.SA_ar))
      : c.SE;
    return String(raw || '').split('\n').map(function(x){ return x.trim(); }).filter(Boolean);
  }
  function countryForLang(){
    return LANG_COUNTRY[currentLang] || state.country || 'SE';
  }
  function syncReportLangOptions(){
    var svBtn = document.querySelector('[data-report-lang="sv"]');
    if(!svBtn) return;
    var show = (currentLang === 'sv');
    svBtn.style.display = show ? '' : 'none';
    if(reportLangExplicit || !state) return;
    // Still just a default -- keep it matching the site language exactly,
    // whichever way it just changed (Swedish site -> Swedish default,
    // English/Arabic site -> that default), not only the "escape from an
    // impossible sv selection" case this used to handle alone.
    if(state.reportLang !== currentLang){
      state.reportLang = currentLang;
      document.querySelectorAll('[data-report-lang]').forEach(function(b){
        b.classList.toggle('sel', b.getAttribute('data-report-lang') === state.reportLang);
      });
    }
  }

  function syncLocationFields(){
    var countryField = document.getElementById('countryField');
    var countrySel = document.getElementById('countrySelect');
    var citySel = document.getElementById('citySelect');
    // setLang() fires once on load, before `state` has been built -- there is
    // nothing to sync yet, and the explicit call further down handles it.
    if(!citySel || !state) return;

    // English is the only language that can't imply a country on its own.
    var pickable = (currentLang === 'en');
    if(countryField) countryField.style.display = pickable ? '' : 'none';
    // Swedish/Arabic imply their country; English does NOT get a silent
    // default that COUNTS AS A CHOICE -- the visitor still has to pick one
    // themselves before checkout. It does get a default DISPLAY price
    // though: without this, a browser that already carries a market cookie
    // from a past Swedish visit (this store's own testing included) would
    // show SEK in English with nothing chosen yet, which reads as random
    // rather than deliberate. Only an actual dropdown pick (see the
    // countrySelEl handler below) ever sets countryChosen, so this default
    // never satisfies the "country is required" validation on its own.
    if(!pickable){
      // sv/ar auto-assign state.country for as long as that language is
      // showing, but this NEVER touches explicitEnglishCountry -- so
      // whatever the customer chose while last in English is still sitting
      // there, untouched, whenever they come back to it.
      state.country = LANG_COUNTRY[currentLang];
    } else {
      // English mode is rebuilt from the customer's own remembered pick on
      // every entry, not from whatever state.country happens to still say
      // (that could be pure leftover from an sv/ar detour) -- '' (the
      // Saudi-display default) when nothing has ever been chosen.
      state.country = explicitEnglishCountry || '';
    }
    if(state.country) switchMarketForCountry(state.country);
    else if(pickable) switchMarketForCountry('SA');

    if(countrySel){
      var wanted = [['SE', T('countrySE')], ['SA', T('countrySA')]];
      countrySel.innerHTML = '<option value="">' + escHtml(T('countryPh')) + '</option>' +
        wanted.map(function(c){
          return '<option value="' + c[0] + '"' + (c[0] === state.country ? ' selected' : '') + '>' + escHtml(c[1]) + '</option>';
        }).join('');
    }

    // No country chosen yet means no city list -- otherwise the disabled
    // dropdown sits there pre-filled with one country's cities for no reason.
    var list = state.country ? citiesFor(state.country) : [];
    // Keep the chosen city across a language switch when that city still
    // exists in the newly selected country's list.
    if(state.city && list.indexOf(state.city) === -1) state.city = '';
    citySel.innerHTML = '<option value="">' + escHtml(T('cityPh')) + '</option>' +
      list.map(function(c){
        return '<option value="' + escHtml(c) + '"' + (c === state.city ? ' selected' : '') + '>' + escHtml(c) + '</option>';
      }).join('');
    citySel.disabled = !state.country || list.length === 0;
  }
  var countrySelEl = document.getElementById('countrySelect');
  if(countrySelEl){
    countrySelEl.addEventListener('change', function(){
      state.country = this.value;
      explicitEnglishCountry = state.country || null;
      state.city = '';
      var cErr = document.getElementById('countryError');
      if(cErr) cErr.style.display = 'none';
      this.classList.remove('invalid');
      syncLocationFields();
      refreshDemoPricing();
      if(state.country) switchMarketForCountry(state.country);
    });
  }
  var citySelEl = document.getElementById('citySelect');
  if(citySelEl){
    citySelEl.addEventListener('change', function(){
      state.city = this.value;
      var err = document.getElementById('cityError');
      if(err) err.style.display = 'none';
      this.classList.remove('invalid');
      refreshDemoPricing();
    });
  }
  function locationLabel(){
    if(!state.city) return '';
    return state.city + ', ' + T(state.country === 'SA' ? 'countrySA' : 'countrySE');
  }

  function showPanel(name){
    document.querySelectorAll('.demo-panel').forEach(function(p){ p.classList.toggle('active', p.dataset.panel===name); });
  }
  function scrollToDemo(){
    document.getElementById('demo-section').scrollIntoView({ behavior:'smooth', block:'start' });
  }

  document.querySelectorAll('[data-open-demo]').forEach(function(btn){
    btn.addEventListener('click', function(){
      state.svc = btn.getAttribute('data-open-demo');
      document.querySelectorAll('[data-mini]').forEach(function(m){ m.classList.toggle('sel', m.dataset.mini===state.svc); });
      showPanel('select');
      scrollToDemo();
    });
  });

  document.querySelectorAll('[data-mini]').forEach(function(m){
    m.addEventListener('click', function(){
      state.svc = m.getAttribute('data-mini');
      document.querySelectorAll('[data-mini]').forEach(function(x){ x.classList.toggle('sel', x===m); });
    });
  });

  document.querySelectorAll('[data-pref]').forEach(function(b){
    b.addEventListener('click', function(){
      state.pref = b.getAttribute('data-pref');
      document.querySelectorAll('[data-pref]').forEach(function(x){ x.classList.toggle('sel', x===b); });
      syncContactField();
    });
  });

  var contactInputEl = document.getElementById('contactInput');
  if(contactInputEl){
    contactInputEl.addEventListener('input', function(){
      if(state.pref === 'whatsapp') state.phone = contactInputEl.value;
      else state.email = contactInputEl.value;
      contactInputEl.classList.remove('invalid');
      var err = document.getElementById('contactError');
      if(err) err.style.display = 'none';
    });
  }

  // Optional -- purely so a returning customer's vehicle shows up already
  // filled in when an inspector later looks them up by phone/email in the
  // inspector tool (see saveCustomerProfileMetaobject on the worker side).
  // Nothing here is validated or required; an empty value just means
  // nothing gets attached to the order.
  var vehicleMakeInputEl = document.getElementById('vehicleMakeInput');
  var vehicleModelInputEl = document.getElementById('vehicleModelInput');
  var vehicleYearInputEl = document.getElementById('vehicleYearInput');
  if(vehicleMakeInputEl) vehicleMakeInputEl.addEventListener('input', function(){ state.vehicleMake = vehicleMakeInputEl.value; });
  if(vehicleModelInputEl) vehicleModelInputEl.addEventListener('input', function(){ state.vehicleModel = vehicleModelInputEl.value; });
  if(vehicleYearInputEl) vehicleYearInputEl.addEventListener('input', function(){ state.vehicleYear = vehicleYearInputEl.value; });

  // Independent from the pref-row above -- this is which language the
  // *report itself* should be written in, not which channel it's
  // delivered through.
  document.querySelectorAll('[data-report-lang]').forEach(function(b){
    b.addEventListener('click', function(){
      state.reportLang = b.getAttribute('data-report-lang');
      reportLangExplicit = true;
      document.querySelectorAll('[data-report-lang]').forEach(function(x){ x.classList.toggle('sel', x===b); });
    });
  });

  // Optional -- carried through to the order the same way the vehicle
  // fields are, so the inspector sees what the customer already flagged
  // instead of starting from nothing.
  var customerNotesInputEl = document.getElementById('customerNotesInput');
  if(customerNotesInputEl) customerNotesInputEl.addEventListener('input', function(){ state.notes = customerNotesInputEl.value; });

  document.getElementById('toPayBtn').addEventListener('click', function(){
    // The inspector has to physically travel to the car, so BOTH the country
    // and the city are required -- unlike the vehicle/notes fields.
    if(!state.country){
      var countrySelNow = document.getElementById('countrySelect');
      var countryErr = document.getElementById('countryError');
      if(countrySelNow) countrySelNow.classList.add('invalid');
      if(countryErr){ countryErr.textContent = T('countryError'); countryErr.style.display = 'block'; }
      if(countrySelNow && countrySelNow.scrollIntoView) countrySelNow.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }
    if(!state.city){
      var citySelNow = document.getElementById('citySelect');
      var cityErr = document.getElementById('cityError');
      if(citySelNow) citySelNow.classList.add('invalid');
      if(cityErr){ cityErr.textContent = T('cityError'); cityErr.style.display = 'block'; }
      if(citySelNow && citySelNow.scrollIntoView) citySelNow.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }
    if(!isValidContact()){
      if(contactInputEl) contactInputEl.classList.add('invalid');
      var err = document.getElementById('contactError');
      if(err){
        err.textContent = state.pref === 'whatsapp' ? T('contactErrorWhatsapp') : T('contactErrorEmail');
        err.style.display = 'block';
      }
      return;
    }
    var btn = this;
    var originalLabel = btn.textContent;
    btn.disabled = true;
    // Whichever payment path the customer picks next (an express button or
    // "Pay now") should only ever add the one item they just confirmed --
    // never stack on top of something left in the cart from an earlier
    // click, a double-click, or a prior abandoned attempt. Clearing here,
    // right before either path can run, is the one place that guarantees
    // that for both of them.
    fetch('/cart/clear.js', { method:'POST' }).catch(function(){}).then(function(){
      btn.disabled = false;
      btn.textContent = originalLabel;
      refreshDemoPricing();
      showPanel('pay');
    });
  });

  var demoSection = document.getElementById('demo-section');
  var VARIANT_IDS = {
    full: demoSection ? demoSection.getAttribute('data-variant-full') : null,
    normal: demoSection ? demoSection.getAttribute('data-variant-normal') : null
  };

  document.getElementById('doPayBtn').addEventListener('click', function(){
    var btn = this;
    var variantId = VARIANT_IDS[state.svc];
    if(!variantId){ return; }
    btn.disabled = true;
    btn.textContent = T('redirecting');
    // Wait for any in-flight country/market switch to finish first -- this
    // is the one path that would otherwise let someone click Pay in the
    // instant between picking a country and its currency actually taking
    // effect, and send them to checkout still priced in the old market.
    marketReady.then(function(){ continueToCheckout(btn, variantId); });
  });
  function continueToCheckout(btn, variantId){

    // A separate /cart/add.js POST followed by a plain /checkout redirect
    // (the old approach) leaves Shopify's own checkout completely blank --
    // confirmed live on this store, the email/WhatsApp number just typed in
    // here does NOT carry over that way, so the customer has to retype it.
    // Shopify's cart PERMALINK route does carry it over, but only when the
    // add and the redirect are the SAME request -- this exact URL shape,
    // confirmed live:
    //   /cart/{variant}:{qty}?attributes[...]=...&checkout[email]=...
    // Two things about it that aren't obvious and were confirmed by testing
    // directly against this store, not assumed from docs:
    //  - line-item `properties[...]` are flatly rejected by this route
    //    ("properties parameter is invalid") -- cart-level `attributes[...]`
    //    is what actually works, so Delivery preference/Language/Contact
    //    live there now instead (still visible on the order, just at the
    //    cart level rather than per line item).
    //  - `checkout[email]` only takes effect through this permalink -- it
    //    does nothing on a bare /checkout redirect after items are already
    //    in the cart, which is exactly what the old code was doing.
    // There's no equivalent field for a phone number: Shopify's hosted
    // checkout always requires a real email address to place any order at
    // all (it's the receipt/account identifier, regardless of delivery
    // preference), and since this product needs no shipping, checkout never
    // shows a phone field to prefill in the first place -- confirmed live,
    // Contact is Email plus a marketing checkbox and nothing else. So a
    // WhatsApp number can only ever ride along as the Contact attribute for
    // the merchant to read off the order, not as a prefilled checkout field.
    var params = new URLSearchParams();
    params.set('attributes[Delivery preference]', state.pref === 'whatsapp' ? 'WhatsApp' : 'Email');
    // The customer's own choice of report language (see the reportLang
    // comment on state's definition above), not necessarily the language
    // the site itself was showing while they booked.
    params.set('attributes[Language]', state.reportLang === 'ar' ? 'Arabic' : state.reportLang === 'sv' ? 'Swedish' : 'English');
    params.set('attributes[Contact]', currentContact());
    // All optional -- an inspector can later look a customer up by phone
    // or email in the inspector tool and, if any of these were given, see
    // the vehicle/notes prefilled instead of starting the report blank
    // (see saveCustomerProfileMetaobject on the worker side). Skipped
    // entirely when empty rather than sent as blank attributes.
    if((state.vehicleMake || '').trim()) params.set('attributes[Vehicle Make]', state.vehicleMake.trim());
    if((state.vehicleModel || '').trim()) params.set('attributes[Vehicle Model]', state.vehicleModel.trim());
    if((state.vehicleYear || '').trim()) params.set('attributes[Vehicle Year]', state.vehicleYear.trim());
    if((state.notes || '').trim()) params.set('attributes[Notes]', state.notes.trim());
    /* The inspector has to travel to the car, so this is operational data,
       not a nicety. Both checkout paths send the SAME two fields -- express
       checkout as line-item properties, this permalink as cart attributes
       (line-item properties[...] are rejected by this route, see above) --
       so an order reads the same whichever way the customer paid. */
    if(state.country) params.set('attributes[Country]', T(state.country === 'SA' ? 'countrySA' : 'countrySE'));
    if(state.city) params.set('attributes[Inspection city]', state.city);
    if(state.pref === 'email' && state.email){
      params.set('checkout[email]', state.email);
    }
    window.location.href = '/cart/' + variantId + ':1?' + params.toString();
  }

  /* Carry a visitor over from the free car-valuation tool
     (/pages/car-value): it stashes the email/phone they entered and the
     car they valued in localStorage, and its "Book an inspection" button
     links here with #demo-section. Prefill those fields and jump to the
     booking flow so they don't retype anything. One hour TTL; consumed on
     use. */
  (function applyValuationHandoff(){
    var raw;
    try{ raw = localStorage.getItem('cardiagnos_booking_prefill'); }catch(e){ return; }
    if(!raw) return;
    var p;
    try{ p = JSON.parse(raw); }catch(e){ p = null; }
    try{ localStorage.removeItem('cardiagnos_booking_prefill'); }catch(e){}
    if(!p || !p.ts || (Date.now() - p.ts) > 3600000) return;

    if(p.phone){ state.phone = p.phone; state.pref = 'whatsapp'; }
    else if(p.email){ state.email = p.email; state.pref = 'email'; }
    document.querySelectorAll('[data-pref]').forEach(function(x){
      x.classList.toggle('sel', x.getAttribute('data-pref') === state.pref);
    });
    if(p.make){ state.vehicleMake = p.make; var mk = document.getElementById('vehicleMakeInput'); if(mk) mk.value = p.make; }
    if(p.model){ state.vehicleModel = p.model; var md = document.getElementById('vehicleModelInput'); if(md) md.value = p.model; }
    if(p.year){ state.vehicleYear = p.year; var yr = document.getElementById('vehicleYearInput'); if(yr) yr.value = p.year; }

    // Always land the visitor on the booking flow -- they came here from the
    // car-valuation "Book an inspection" button (href = /#demo-section). The
    // page is tall and its media keeps pushing #demo-section down for a
    // second or two after load, so a single scroll lands short; re-align a
    // handful of times over ~2.5s as it settles, then stop.
    var alignEnd = Date.now() + 2600, alignRuns = 0;
    var alignBooking = function(){
      alignRuns++;
      var ds = document.getElementById('demo-section');
      if(ds){
        var top = ds.getBoundingClientRect().top;
        if(Math.abs(top) > 4) ds.scrollIntoView({ block: 'start', behavior: alignRuns > 1 ? 'smooth' : 'auto' });
      }
      if(Date.now() < alignEnd) setTimeout(alignBooking, 300);
    };
    setTimeout(alignBooking, 60);
    if(document.readyState !== 'complete') window.addEventListener('load', function(){ setTimeout(alignBooking, 60); });
  })();

  syncContactField();
  syncVehiclePlaceholders();
  syncReportLangOptions();
  syncLocationFields();
  /* Paint the real price once, unconditionally, now that state definitely
     exists. Every other call site is conditional on something HAPPENING
     (a language switch, an explicit country pick, a market-switch response
     resolving) -- none of them fire on a plain page load with no
     interaction yet, so the price fields were stuck showing the server-
     rendered Liquid fallback text (the theme-setting number) forever, even
     though svcData itself was already correctly seeded from LCFG.prices
     (the REAL live price for whatever market this session's page load
     resolved into) the whole time. */
  refreshDemoPricing();
  // The report-language buttons default to "English" selected in the
  // markup itself -- if this visitor's site language (and so the initial
  // state.reportLang) is actually Arabic, sync the visible selection to
  // match on load rather than leaving it silently wrong until they click.
  document.querySelectorAll('[data-report-lang]').forEach(function(b){
    b.classList.toggle('sel', b.getAttribute('data-report-lang') === state.reportLang);
  });

  document.querySelectorAll('[data-back]').forEach(function(b){
    b.addEventListener('click', function(){ showPanel(b.getAttribute('data-back')); });
  });

  document.getElementById('restartBtn').addEventListener('click', function(){
    showPanel('select');
  });

  // inspectorLink/inspectorLink2 are plain <a href="/"> tags in the markup --
  // real navigation to the inspector tool's homepage, no JS needed.
})();
